import React from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { FunctionProperty } from '../../../../../../../../lib/commons/appFunction'
import { WbsItemRow } from '../../../../../../../../lib/functions/wbsItem'
import ViewMeta from '../../../../../../meta/ViewMeta'
import { WbsItemIcon } from '../../../../../../../components/icons/WbsItemIcon'
import IconTextField from '../../common/iconText'

interface Props extends ICellRendererParams {
  value: Partial<WbsItemRow>
  data: any
  uiMeta: FunctionProperty
  viewMeta: ViewMeta
}

class WbsItemBasicCellRenderer extends React.PureComponent<Props> {
  // 描画に影響するpropsのみを比較
  shouldComponentUpdate(nextProps: Props): boolean {
    const prevWbsItem = this.props.value
    const nextWbsItem = nextProps.value

    // valueが両方nullish
    if (!prevWbsItem && !nextWbsItem) return false
    // 片方だけnullish
    if (!prevWbsItem || !nextWbsItem) return true

    // 描画に関係するプロパティを比較
    if (prevWbsItem.displayName !== nextWbsItem.displayName) return true
    if (prevWbsItem.wbsItemType !== nextWbsItem.wbsItemType) return true
    if (prevWbsItem.projectUuid !== nextWbsItem.projectUuid) return true
    if (prevWbsItem.uuid !== nextWbsItem.uuid) return true

    return false
  }

  render() {
    const wbsItem = this.props.value
    if (!wbsItem) {
      return <></>
    }
    return (
      <IconTextField
        icon={<WbsItemIcon type={wbsItem.wbsItemType} />}
        enableTooltip={false}
        value={wbsItem.displayName ?? ''}
        data={this.props.data}
        uiMeta={this.props.uiMeta}
        viewMeta={this.props.viewMeta}
      />
    )
  }
}

export default WbsItemBasicCellRenderer
